import { Drawer, Flex, Typography, theme } from 'antd';
import type { TopAdvertiser } from '@/types';
import PaginatedList from '../../PaginatedList';
import AdvertiserEcho from './AdvertiserEcho';
import useFilterContext from '@/context/useFilterContext';

const dateFormatter = new Intl.DateTimeFormat('en-US', {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  timeZone: 'UTC',
});

export const AdvertisersDrawerEcho = ({
  isOpen = false,
  data = [],
  handleClose,
}: {
  isOpen: boolean;
  data: TopAdvertiser[];
  handleClose: () => void;
}) => {
  const { token } = theme.useToken();
  const { filters } = useFilterContext();
  const { dateRange } = filters;

  const isSingleDay =
    dateFormatter.format(new Date(dateRange.from)) === dateFormatter.format(new Date(dateRange.to));

  const dateRangeDesc = `For revenue earned ${
    isSingleDay ? 'on' : 'between'
  } ${dateFormatter.formatRange(new Date(dateRange.from), new Date(dateRange.to))}`;

  const drawerTitle = (
    <div>
      <Typography.Title level={3} style={{ margin: 0 }}>
        Top advertisers
      </Typography.Title>
      <Typography.Text style={{ color: token.colorTextTertiary, fontSize: token.fontSizeSM }}>
        {dateRangeDesc}
      </Typography.Text>
    </div>
  );

  return (
    <Drawer
      open={isOpen}
      onClose={handleClose}
      size={960}
      title={drawerTitle}
      data-testid="advertisers-drawer"
    >
      <Flex
        vertical
        justify="space-between"
        style={{ flexGrow: 1, paddingBlock: token.padding, paddingInline: token.paddingLG }}
      >
        <PaginatedList
          data={data}
          renderItem={(item: TopAdvertiser) => (
            <Flex vertical style={{ paddingBottom: token.paddingXL }}>
              <AdvertiserEcho data={item} format="full" />
            </Flex>
          )}
        />
      </Flex>
    </Drawer>
  );
};
